import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./navbar.module.css";

function NavBar({ current, setDisappear, userPermissions }) {

  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location ? location : "";
  const [leaveAnimation, setLeaveAnimation] = useState(false);

  function handleTransitionMenu() {
    setLeaveAnimation(true);
    if (setDisappear) setDisappear(true);
    setTimeout(() => {
      navigate("/")
    }, 1100);
  }
  
  return (
    <div style={{paddingTop: "0.5rem"}}>
      {
        userPermissions ?
          <nav className={styles.navBar}>
            <div style={leaveAnimation ? {zIndex: "0"} : {opacity: "0", zIndex: "-1"}}  className={`${styles.logoOut} ${ leaveAnimation ? styles.animateLogoOut : ""}`}/>
            <div onClick={() => handleTransitionMenu()} style={leaveAnimation ? {opacity: "0"} : {}} className={styles.logo}/>
            <ul className={`${leaveAnimation ? styles.animateOut : state?.animate ? styles.animateIn :  ""}`}>
              {
                userPermissions.empresas || userPermissions.cartoes ?
                  <li onClick={() => navigate("/empresas")} className={current === "empresas" ? styles.active : ""}>
                    Empresas
                  </li>
                :""
              }
              {
                userPermissions.unidades ?
                  <li onClick={() => navigate("/unidades")} className={current === "unidades" ? styles.active : ""}>
                    Unidades
                  </li>
                :""
              }
              {
                userPermissions.colaboradores || userPermissions.cartoes ?
                  <li onClick={() => navigate("/colaboradores")} className={current === "colaboradores" ? styles.active : ""}>
                    Colaboradores
                  </li>
                :""
              }
              {
                userPermissions.campanhas ?
                  <li onClick={() => navigate("/campanhas")}className={current === "campanhas" ? styles.active : ""}>
                    Campanhas e Eventos
                  </li>
                :""
              }
              {
                userPermissions.protocolos ?
                  <li onClick={() => navigate("/protocolos")} className={current === "protocolos" ? styles.active : ""}>
                    Protocolos
                  </li>
                :""
              }
              {
                userPermissions.comunicacoes ?
                  <li onClick={() => navigate("/comunicacoes-internas")} className={current === "comunicacoes-internas" ? styles.active : ""}>
                    Comunicações Internas
                  </li>
                :""
              }
              {
                userPermissions.eventos ?
                  <li onClick={() => navigate("/calendario")} className={current === "calendario" ? styles.active : ""}>
                    Agenda
                  </li>
                :""
              }
              {
                userPermissions.colaboradores ?
                  <li onClick={() => navigate("/utilizadores")} className={current === "utilizadores" ? styles.active : ""}>
                    Utilizadores
                  </li>
                :""
              }
            </ul>
          </nav>
        :""
      }
    </div>
  );
}

export default NavBar;